import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { SearchService } from 'src/app/Services/search.service';
declare var $: any;

@Component({
  selector: 'app-bss-curve',
  templateUrl: './bss-curve.component.html',
  styleUrls: ['./bss-curve.component.css']
})
export class BssCurveComponent implements OnInit {
  bsscurvelist: any;
  constructor(private httpRequestService: HttpRequestService,
    private searchService: SearchService,
    public sanitizer: DomSanitizer,
    private router: Router, private property: PropertiesService) { }

  ngOnInit() {
    this.getGridData();
  }

  getGridData() {
    this.getData().then((list: any) => {
      this.bsscurvelist = list.result.Table1;
      
    });

  }
  getData() {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.property.WebAPIipAndPort.concat(this.property.BSSAPI) + "/HR/LoadBSSCurve")
        .then((res: any) => {
          console.log('Response', res);
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }

  downloadFile(FileName) {
    
    this.httpRequestService.get(this.property.WebAPIipAndPort.concat(this.property.BSSAPI) + "/FileStorage/downloadFileHR?fileName=" + FileName + '&FolderName=EMS/Docs/bss curve')
      .then((data: any) => {
        if (data && data.response) {
          $('#modal-container').removeAttr('class').addClass('four');
          $('body').addClass('modal-active');
          $('#dvprint').html(data.Additional1);
          return;
          // let binaryString = window.atob(data.response);
          // let binaryLen = binaryString.length;
          // let bytes = new Uint8Array(binaryLen);
          // for (let i = 0; i < binaryLen; i++) {
          //   let ascii = binaryString.charCodeAt(i);
          //   bytes[i] = ascii;
          // }
          // let file = new Blob([bytes], { type: data.status });
          // var fileURL = URL.createObjectURL(file);
          // window.open(fileURL);
        }
      });
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.closepopups();
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    //alert('');
    event.preventDefault();
  }

  closepopups() {
    $('#modal-container').addClass('out');
    setTimeout(function () { $('#modal-container').removeClass('four'); }, 500);
    $('body').removeClass('modal-active');
  }

}
